export class Documents {
  File: File;
  number: number;
  base64: string;
  fechaComprobanteDomicilio: string;
  name: string;
  idDocument: number;
}
